<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{ $t("orderList.orderList2") }}:</div>
              <div class="flex1">
                <el-input :placeholder="$t('orderList.orderList3')" clearable v-model="queryInfo.id" size="small" @keyup.enter.native="searchList"></el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{ $t("mail.mailTo") }}:</div>
              <div class="flex1">
                <el-input :placeholder="$t('orderList.orderList3')" clearable v-model="queryInfo.receiver" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">
                {{ $t("common.createStartDate") }}:
              </div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeStart" type="datetime" size="small" format="yyyy-MM-dd HH:mm:ss"
                  value-format="timestamp" default-time="00:00:00" :picker-options="createTimeStartPickerOptions"
                  :placeholder="$t('common.selectDate')" @change="handleCreateTimeStartChange">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{ $t("common.createEndDate") }}:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="datetime" size="small" format="yyyy-MM-dd HH:mm:ss"
                  value-format="timestamp" default-time="23:59:59" :picker-options="createTimeEndPickerOptions"
                  :placeholder="$t('common.selectDate')" @change="handleCreateTimeEndChange">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{ $t("orderList.orderList5") }}:</div>
              <div class="flex1">
                <el-input :placeholder="$t('orderList.orderList3')" clearable v-model="queryInfo.trackingNumberCn" size="small"
                  @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">商品SKU:</div>
              <div class="flex1">
                <el-input placeholder="商品SKU" clearable v-model="queryInfo.goodsNumber" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">品名:</div>
              <div class="flex1">
                <el-input placeholder="品名" clearable v-model="queryInfo.goodsNameCus" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t("cart.cart24")}}:</div>
              <div class="flex1">
                <el-input :placeholder="$t('cart.cart24')" clearable v-model="queryInfo.fnsku" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title1">FBA/YFF/RSL:</div>
              <div class="flex1" style="">
                <el-select v-model="queryInfo.orderType" placeholder="FBA/YFF/RSL" size="small">
                  <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" class="display-row" v-if="isClientManage === '1'">
              <div class="query-title1">{{ $t("cnumber.cnumber20") }}:</div>
              <div class="flex1">
                <ChildCode v-model="queryInfo.customerUserId"></ChildCode>
              </div>
            </el-col>
            <el-col :span="6" class="display-row" v-if="isClientManage === '0'">
              <div class="query-title1"></div>
              <div class="flex1"></div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">ASIN:</div>
              <div class="flex1">
                <el-input clearable v-model="queryInfo.asin" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="display-row lx-flex-end">
              <div class="show-btn-container" style="display: flex">
                <el-button class="search-btn btn-gray mb-8" @click="queryInfoClear">{{ $t("reset") }}</el-button>
                <el-button class="search-btn btn-blue mb-8" @click="searchList">{{
                  $t("query")
                }}</el-button>
                <el-button class="search-btn btn-green mb-8" @click="doAddCart">{{
                  $t("orderList.addCart")
                }}</el-button>
                <el-button class="search-btn btn-green mb-8" @click="toSort">{{
                  $t("orderList.orderList156"||'列表调整')
                }}</el-button>

                <span v-if="curIndex == 1 || curIndex == 10" class="mb-8" style="display:flex;flex:1;justify-content: flex-end;">
                  <el-button style="margin-right: -5px;" class="search-btn btn-green" @click="handleOrderClear">{{ $t("orderList.orderList157") }}</el-button>
                </span>
                <span class="display-row mb-8" v-if="!falg">
                  <el-button v-if="isClientManage === '1' && isSame" class="search-btn btn-green" @click="plfpFunc">{{ $t("cnumber.cnumber17") }}</el-button>
                  <el-button class="search-btn btn-green" @click="orderClearTimeSave">{{ $t("orderList.orderList139") }}</el-button>
                  <el-button class="search-btn btn-green" @click="orderExport">{{
                      $t("export")
                    }}</el-button>
                  <!-- <el-button class="search-btn btn-green" @click="calculateCost">{{
                      $t("orderList.orderList124")
                    }}</el-button> -->

                </span>
                <span class="display-row mb-8" v-if="falg">
                  <!-- 计算结果 -->
                  <!-- <span class="fz-num"
                    >{{ $t("orderList.orderList135") }}：{{ numTotal }}</span
                  >
                  &nbsp; &nbsp;
                  <span class="fz-num"
                    >{{ $t("orderList.orderList120") }}：{{ num
                    }}{{ $t("orderList.orderList121") }}</span
                  > -->
                  <el-button class="search-btn btn-green" @click="goRecharge">{{
                      $t("createOrder.createOrder8")
                    }}</el-button>
                  <el-button class="search-btn btn-green" @click="expenseExport">{{
                      $t("orderList.orderList122")
                    }}</el-button>
                  <!-- <el-button class="search-btn btn-green" @click="calculateCost">{{
                      $t("orderList.orderList123")
                    }}</el-button> -->
                </span>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <div class="search-row flex-wrap">
          <div class="display-row">
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 0 }"
              @click="quickSearchList('', (index = 0))">{{ $t("wzbg.wz19") }}</el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 1 }" @click="quickSearchList('1,3,5', (index = 1))">{{ $t("orderList.orderList6")
              }}<span v-if="orderData.pendingPurchaseCount > 0" class="lx-red">({{ orderData.pendingPurchaseCount }})</span></el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 2 }" @click="quickSearchList('2', (index = 2))">{{ $t("orderList.orderList7")
              }}<span v-if="orderData.purchasedCount > 0" class="lx-red">({{ orderData.purchasedCount }})</span></el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 3 }" @click="quickSearchList('0', (index = 3))">{{ $t("orderList.orderList8")
              }}<span v-if="orderData.waitWarehouseCount > 0" class="lx-red">({{ orderData.waitWarehouseCount }})</span></el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 4 }" @click="quickSearchList('4', (index = 4))">{{ $t("orderList.orderList127")
              }}<span v-if="orderData.arrivalCount > 0" class="lx-red">({{ orderData.arrivalCount }})</span></el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 5 }" @click="quickSearchList('8', (index = 5))">{{ $t("orderList.orderList115")
              }}<span v-if="orderData.checkingCount > 0" class="lx-red">({{ orderData.checkingCount }})</span></el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 9 }"
                       @click="quickSearchList('24,28,32,36,68,40,82,26', (index = 9))">{{ $t("orderList.orderList12")
              }}<span v-if="orderData.badOrderCount > 0" class="lx-red">({{ orderData.badOrderCount }})</span></el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 6 }" @click="quickSearchList('88', (index = 6))">{{ $t("orderList.orderList128")
              }}<span v-if="orderData.checkedCount > 0" class="lx-red">({{ orderData.checkedCount }})</span></el-button>

<!--            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 8 }" @click="quickSearchList('16', (index = 8))">{{ $t("orderList.orderList10")-->
<!--              }}<span v-if="orderData.warehouseStorageCount > 0" class="lx-red">({{ orderData.warehouseStorageCount }})</span></el-button>-->


            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 7 }" @click="quickSearchList('48', (index = 7))">{{ $t("orderList.orderList72")
              }}<span v-if="orderData.waitApplyCount > 0" class="lx-red">({{ orderData.waitApplyCount }})</span></el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 11 }"
              @click="quickSearchList('72,84,52', (index = 11))">{{ $t("orderList.orderList13") }}</el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 10 }" @click="quickSearchList('89', (index = 10))">{{ $t("orderList.orderList109")
              }}</el-button>
            <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 12 }"
                       @click="quickSearchList('56', (index = 12))">{{ $t("status.status4") }}</el-button>
            <!-- <el-button
              class="search-btn btn-white"
              :class="{lxBtnGreenDeep: curIndex === 9}"
              @click="quickSearchList('56',index = 9)"
            >{{$t('status.status4')}}</el-button> -->
          </div>
          <div class="display-row" v-if="!falg">
            <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt=""
              @click="isActive = !isActive">{{ $t("search.expandPanel") }}</el-button>
            <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt=""
              @click="isActive = !isActive">{{ $t("search.retractPanel") }}</el-button>
          </div>
        </div>
      </div>

      <div slot="table" class="lx-table-wrapper lx-flex-grow-1 lx-hidden lx-relative">
        <lx-table :showIndexCode="false" :loading="isLoading" :list="orderList" isSelectTable border stripe :rowKey="'id'" :emptyText="$t('select.select24')"
          :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" @selectionChange="orderSelectedChanged">
          <el-table-column v-for="(item, index) in displayColumns" :key="index" :align="item.align" :label="item.name" :prop="item.key"
            :width="item.width ? item.width : 'auto'" :min-width="item.minWidth ? item.minWidth : '280'">
            <template v-slot="scope">
              <!-- 操作 -->
              <div v-if="item.key === 'handle'">
                <div class="lx-flex" style="font-weight: 700;">
                  <span>{{$t('createOrder.createOrder104')}}：</span>
                  <div class="lx-flex lx-flex-wrap lx-flex-grow-1">
                    <span>{{ scope.row.id }}</span>
                    <div v-if="scope.row.splitOrderId" class="ml-10">
                      <font color="#0082FF" @click="
                          $router.push({
                            name: 'orderDetail',
                            query: { id: scope.row.splitOrderId, isEdit: '0' },
                          })
                        " style="cursor: pointer">{{ scope.row.splitOrderId }}-{{ scope.row.splitSeq }}</font>
                    </div>
                  </div>
                </div>
                <p>{{$t('createOrder.createOrder102')}}：{{ scope.row.userName }}</p>
                <div class="lx-flex">
                  <span class="white-space-nowrap">{{$t('model.createTime')}}：</span>
                  <div class="lx-flex lx-flex-grow-1 lx-flex-wrap">
                    <span class="mr-10">{{ scope.row.createTime | dateFormatToNYR }}</span>
                    <span>{{ scope.row.createTime | dateFormatToSFM }}</span>
                  </div>
                </div>
                <!-- <p>{{$t('model.createTime')}}：{{ scope.row.createTime | dateFormatToNYR }}</p> -->
                <!-- <p><span style="opacity: 0">{{$t('model.createTime')}}：</span>{{ scope.row.createTime | dateFormatToSFM }}</p> -->
                <p style="color: #ff0000" v-if="scope.row.clientManagerUserName">{{$t('cnumber.cnumber30')}}：{{ scope.row.clientManagerUserName }}</p>
                <div>
                  <el-button class="list-btn btn-blue" @click="toOrderDetail(scope.row)">
                    {{ $t("detail") }}</el-button>
                  <el-button class="list-btn btn-green" v-if="
                    scope.row.orderStatus == 1 ||
                    (scope.row.orderStatus == 0) & (scope.row.agentFlag == 0)
                  " @click="toEditOrder(scope.row)">
                    {{ $t("editor") }}</el-button>
<!--                  <el-button class="list-btn btn-deepblue" v-if="['1'].indexOf(scope.row.orderStatus) > -1" @click="toRefundOrder(scope.row)">-->
<!--                    {{ $t("orderList.orderList16") }}</el-button>-->
                  <el-button class="list-btn btn-deepblue" v-if="['60'].indexOf(scope.row.orderStatus) > -1" @click="toRefundOrderCannel(scope.row)">
                    {{ $t("orderList.orderList17") }}</el-button>
                  <el-button class="list-btn btn-deepblue" v-if="
                    ['0', '4', '8', '12', '16'].indexOf(scope.row.orderStatus) >
                    -1
                  " @click="toDestroyOrder(scope.row)">
                    {{ $t("orderList.orderList18") }}</el-button>
                  <el-button class="list-btn btn-deepblue" v-if="['76'].indexOf(scope.row.orderStatus) > -1" @click="toDestroyOrderCannel(scope.row)">
                    {{ $t("orderList.orderList19") }}</el-button>
                  <el-button class="list-btn btn-green" v-if="
                    ['0', '1', '2', '4', '8', '16'].indexOf(
                      scope.row.orderStatus
                    ) > -1 && scope.row.goodsCount > 1
                  " @click="toSpiltOrder(scope.row)">
                    {{ $t("orderList.orderList20") }}</el-button>
                  <el-button class="list-btn btn-deepblue" v-if="
                    ['1'].indexOf(scope.row.orderStatus) > -1 ||
                    (['0'].indexOf(scope.row.orderStatus) > -1 &&
                      scope.row.agentFlag === '0')
                  " @click="toCancelOrder(scope.row)">
                    {{ $t("cancel") }}</el-button>
                  <el-button class="list-btn btn-blue" @click="messageAdd(scope.row)">{{ $t("orderList.orderList23") }}</el-button>
                  <el-button v-show="scope.row.orderStatus == 24" class="list-btn-four btn-blue" @click="
                    $router.push({
                      path: '/defective',
                      query: { orderid: scope.row.id },
                    })
                  ">
                    {{ $t("orderList.orderList24") }}
                  </el-button>
                  <!-- 订单分配 -->
                  <el-button class="list-btn btn-blue" v-if="isClientManage === '1' && scope.row.orderStatus != 5" @click="fpItem(scope.row)">{{ $t("cnumber.cnumber19") }}</el-button>

                </div>

              </div>
              <!-- 检品报告 -->
              <div v-if="item.key === 'checkReport'">
                <span v-if="!scope.row.checkReport && ['88', '48', '52', '72', '84'].includes(scope.row.orderStatus)">{{ $t("orderList.orderList144") }}
                </span>
                <span v-else-if="!scope.row.checkReport && !['88', '48', '52', '72', '84'].includes(scope.row.orderStatus)">-</span>
                <div v-else>
                  <span>{{ $t("orderList.orderList145") }}</span>
                  <div>
                    <el-button class="list-btn btn-blue" style="margin-right: 0!important;" @click="checkReportView(scope.row.checkReport)">
                      {{ $t("orderList.orderList146") }}
                    </el-button>
                  </div>
                  <div>
                    <el-button class="list-btn btn-blue" style="margin-right: 0!important;" @click="checkReportDownload(scope.row.checkReport)">
                      {{ $t("orderList.orderList147") }}</el-button>
                  </div>
                </div>
              </div>
              <!-- 订单编号 -->
              <!-- <div v-else-if="item.key === 'splitOrderId'">
                <div>
                  <span>{{ scope.row.id }}</span>
                </div>
                <div v-if="scope.row.splitOrderId">
                  <font color="#0082FF" @click="
                      $router.push({
                        name: 'orderDetail',
                        query: { id: scope.row.splitOrderId, isEdit: '0' },
                      })
                    " style="cursor: pointer">{{ scope.row.splitOrderId }}-{{ scope.row.splitSeq }}</font>
                </div>
              </div> -->
              <!-- 创建时间 -->
              <!-- <div v-else-if="item.key === 'createTime'">
                {{ scope.row.createTime | dateFormatToSecond }}
              </div> -->
              <!-- 同捆 -->
              <!-- <el-link v-else-if="item.key === 'tongkunNo'" :underline="true" @click="toTongkunDetail(scope.row)">
                                {{scope.row.tongkunNo==null?'':scope.row.tongkunNo+(scope.row.orderCount==null?'':'('+scope.row.orderCount+')')}}
                            </el-link> -->
              <!-- 国内信息 -->
              <div v-else-if="item.key === 'trackingNumberCn'">
                <div><span>{{$t('orderList.orderList119')}}：</span>{{ scope.row.chineseFreightFee }}</div>
                <div v-if="(scope.row.orderStatus !== '1' && scope.row.orderStatus !== '2' && scope.row.trackingNumberCn) || scope.row.cnLogisticsStatus">
                  <span>{{$t('saas.saas02')}}：</span>
                    <span
                      v-if="scope.row.orderStatus !== '1' && scope.row.orderStatus !== '2'"
                      :title="scope.row.trackingNumberCn"
                    >
                      {{ scope.row.trackingNumberCn }}
                  </span>
                  <span :title="scope.row.cnLogisticsStatus" class="overflow2Dot">
                    {{ scope.row.cnLogisticsStatus }}
                  </span>
                </div>
                <div v-if="scope.row.arrivalTime">
                  <span>{{ $t("select.select10") }}：</span>
                  <div style="white-space: pre-wrap">{{timerLineFeed(scope.row.arrivalTime)}}</div>
                </div>
              </div>
              <!-- 国际物流 -->
              <!-- <div v-else-if="item.key === 'trackingNumberJpn'">
                                <div class="btn-row">
                                    {{scope.row.trackingNumberJpn}}
                                </div>
                                <div class="btn-row overflowDot" :title="scope.row.sagawaState">
                                    {{scope.row.sagawaState}}
                                </div>
                            </div> -->
              <!-- 序号/订单状态 -->
              <div style="text-align: center" class="btn-row" v-else-if="item.key === 'orderStatus'">
                <p style="margin-bottom: 10px;">{{scope.$index + 1}}</p>
                {{ scope.row.orderStatus | orderStatusFilter }}
              </div>
              <!-- 商品信息 -->
              <div v-else-if="item.key === 'shopInfo'">
                <div style="display: flex; align-items: center;">
                  <div class="goods-info-container">
                    <img @click="imgclick(scope.row.pictureUrl, true)" v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0"
                      :src="scope.row.pictureUrl + commonData.smallimg" alt="" class="list-image" />
                    <img v-else src="../../../assets/images/default.png" alt="" class="list-image" />
                    <div style="position: absolute; top: 0; right: -11px;">
                      <img class="goods-detail-link" :src="require('@/assets/img/跳转链接.svg')" alt="" @click="toGoodsDetail(scope.row)" />
                    </div>
                  </div>
                  <div style="display: flex;flex-direction: column;align-items: flex-start;flex: 1;min-width: 0;">
                    <!-- Color -->
                    <div class="lx-text-left-row" v-if="scope.row.colour" style="font-size: 12px!important; width: 100%; display: flex; align-items: center;">
                      <div style="width: 52px;min-width: 52px; text-align: right; white-space: nowrap;" class="table-cell-title-min">
                        {{ $t("orderList.orderList26") }}：
                      </div>
                      <el-tooltip :content="scope.row.colour" placement="top" effect="light">
                        <div style="flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px; text-align: left;">{{ scope.row.colour }}</div>
                      </el-tooltip>
                    </div>
                    <!-- SKU -->
                    <div class="lx-text-left-row" style="display: flex; width: 100%; align-items: center;">
                      <div style="width: 52px;min-width: 52px; text-align: right; white-space: nowrap;" class="table-cell-title-min">
                          SKU：
                      </div>
                      <el-tooltip style="width: 100%;" :content="scope.row.goodsNumber" placement="top" effect="light" :disabled="!scope.row.goodsNumber" :open-delay="300">
                        <el-input class="sku-input" placeholder="SKU" style="width: 100%;" @change="quickSave($event, scope.row)" v-model="scope.row.goodsNumber" size="mini">
                        </el-input>
                      </el-tooltip>
                    </div>
                    <!-- Size -->
                    <div class="lx-text-left-row" v-if="scope.row.goodsSize" style="font-size: 12px!important; width: 100%; display: flex; align-items: center;">
                      <div style="width: 52px;min-width: 52px; text-align: right; white-space: nowrap;" class="table-cell-title-min">
                        {{ $t("orderList.orderList27") }}：
                      </div>
                      <el-tooltip :content="scope.row.goodsSize" placement="top" effect="light">
                        <div style="flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px; text-align: left;">{{ scope.row.goodsSize }}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 商品备注 -->
              <div v-else-if="item.key === 'merchantRemark'">
                <el-tooltip v-if="scope.row.merchantRemark" :content="scope.row.merchantRemark" placement="top" effect="dark">
                  <div class="text-row-2">
                    {{ scope.row.merchantRemark }}
                  </div>
                </el-tooltip>
                <span v-else>-</span>
              </div>
              <!-- 单价（元） -->
              <div v-else-if="item.key === 'price'">
                <div class="lx-text-right">
                  {{ Number(scope.row.price) }}
                </div>
              </div>

              <!-- 商品数量 -->
              <div v-else-if="item.key === 'shopNum'">
                <div class="lx-text-left" v-if="shopNumOnlyShowTotal">
                  <span class="table-cell-title-mid">{{ $t("orderList.orderList148") }}：</span>
                  <span>{{ scope.row.goodsCount }}</span>
                </div>
                <template v-else>
                  <div class="lx-text-left">
                    <span class="table-cell-title-mid">{{ $t("orderList.orderList148") }}：</span>
                    <span>{{ scope.row.goodsCount }}</span>
                  </div>
                  <div class="set-number">
                    <div class="lx-text-left">
                      <span class="table-cell-title-mid">{{ $t("orderList.orderList153") }}：</span>
                      <span>{{ scope.row.canBoxCount }}</span>
                    </div>
                    <div class="lx-text-left">
                      <span class="table-cell-title-mid">{{ $t("orderList.orderList150") }}：</span>
                      <span>{{ scope.row.waitBoxCount }}</span>
                    </div>
                    <div class="lx-text-left">
                      <span class="table-cell-title-mid">{{ $t("orderList.orderList149") }}：</span>
                      <span>{{ scope.row.boxedGoodsCount }}</span>
                    </div>
                    <div class="lx-text-left" v-if="scope.row.refundCount && scope.row.refundCount > 0">
                      <span class="table-cell-title-mid">{{ $t("orderList.orderList151") }}：</span>
                      <span>{{ scope.row.refundCount }}</span>
                    </div>
                    <div class="lx-text-left" v-if="scope.row.destroyCount && scope.row.destroyCount > 0">
                      <span class="table-cell-title-mid">{{ $t("orderList.orderList152") }}：</span>
                      <span>{{ scope.row.destroyCount }}</span>
                    </div>
                    <div class="lx-text-left">
                      <span class="table-cell-title-mid">{{ $t("orderList.orderList154") }}：</span>
                      <span>{{ scope.row.sendCount }}</span>
                    </div>
                  </div>
                </template>
              </div>

              <!-- 检品 -->
              <div style="text-align: left" v-else-if="item.key === 'inspection'" class="lx-text-left">
                <div v-for="item in scope.row.inspection.split(',').slice(0, 4)" :key="item">
                  {{ item }}
                </div>
                <div v-if="scope.row.inspection && scope.row.inspection.split(',').length > 4">
                  <el-tooltip placement="bottom" effect="light">
                    <template #content>
                      <div style="text-align: left" v-for="item in scope.row.inspection.split(',')" :key="item">
                        {{ item }}
                      </div>
                    </template>
                    <div style="cursor: pointer">...</div>
                  </el-tooltip>
                </div>
<!--                <span v-if="scope.row.inspection && scope.row.inspection.length > 0">
                  <div v-for="item in scope.row.inspection.split(',')" :key="item">
                    {{ item }}
                  </div>
                </span>-->
              </div>
              <!-- 仓库保管 -->
              <div style="text-align: center" v-else-if="item.key === 'categoryFlag'">
                <!--                {{ scope.row.categoryFlag == 0 ? $t('running.suspended0') : $t('running.suspended1') }}-->
                <div>
                  <span v-if="
                      scope.row.warehouseStorageDays != null &&
                      !['52', '72', '84'].includes(scope.row.orderStatus) &&
                      scope.row.checkFinishTime != null
                    ">
                    <span v-if="scope.row.warehouseStorageDays >= 10">
                      {{ $t("orderList.orderList140") }}
                      {{ scope.row.warehouseStorageDays }}日
                    </span>
                    <span v-if="
                        scope.row.warehouseStorageDays < 10 &&
                        scope.row.warehouseStorageDays > 0
                      " style="color: orange">
                      {{ $t("orderList.orderList140") }}
                      {{ scope.row.warehouseStorageDays }}日
                    </span>
                    <span v-if="scope.row.warehouseStorageDays == 0" style="color: red">
                      {{ $t("orderList.orderList140") }}
                      {{ scope.row.warehouseStorageDays }}日
                    </span>
                  </span>
                  <span v-else-if="
                      scope.row.chargingDays > 0 &&
                      !['52', '72', '84'].includes(scope.row.orderStatus) &&
                      scope.row.categoryPrice != 0 &&
                      scope.row.freeWarehousing == '0'
                    ">{{ $t("orderList.orderList141")
                    }}{{ scope.row.categoryPrice }}元({{
                      $t("orderList.orderList142")
                    }}{{ scope.row.chargingDays }}日)</span>
                  <!-- <span v-else-if="['2', '0', '4', '8'].includes(scope.row.orderStatus)">{{ scope.row.freeWarehousing === '1' ? $t('common.yes') : $t('common.no') }}</span> -->
                  <span v-else-if="scope.row.freeWarehousing === '1'">{{ $t('common.yes') }}</span>
                  <span v-else-if="scope.row.freeWarehousing === '0'">{{ $t('common.no') }}</span>
                </div>
                <!--                <div class="btn-row"-->
                <!--                  v-if="scope.row.categoryFlag == '0' && storeKeepingStatus.indexOf(scope.row.orderStatus) > -1">-->
                <!--                  <el-button class="list-btn btn-blue" @click="toStoreKeeping(scope.row)">-->
                <!--                    {{ $t('update') }}</el-button>-->
                <!--                </div>-->
                <!--                <div class="btn-row"-->
                <!--                  v-if="scope.row.categoryFlag == '1' && scope.row.orderStatus == '16' && scope.row.applicationSend != '1'">-->
                <!--                  <el-button class="list-btn btn-green" @click="toSendOrder(scope.row)">-->
                <!--                    {{ $t('orderList.orderList33') }}</el-button>-->
                <!--                </div>-->
              </div>
              <!-- 包装意向 -->
              <div style="text-align: center" v-else-if="item.key === 'putIntent'">
                {{ scope.row.putIntent | putIntentFilter }}
              </div>
              <!-- 图片 -->
              <!-- <div style="text-align: center" v-else-if="item.key === 'pictureUrl'">
                <img @click="imgclick(scope.row.pictureUrl, true)" v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0"
                  :src="scope.row.pictureUrl + commonData.smallimg" alt="" class="list-image" />
                <img v-else src="../../../assets/images/default.png" alt="" class="list-image" />
                <div class="btn-row">
                  <el-button class="list-btn-four btn-blue" @click="toGoodsDetail(scope.row)">
                    {{ $t("menu.menu5") }}
                  </el-button>
                </div>
              </div> -->
              <!-- 是否fba -->
              <div style="text-align: center" v-else-if="item.key === 'orderType'">
                {{ scope.row.orderType | ordertypeFilter }}
<!--                <div v-if="scope.row.orderType == 1">
                  <span style="margin-right: 10px">バーコード:</span>{{ scope.row.fnsku }}
                </div>-->
                <div v-if="scope.row.orderType == 0">
                  <span style="margin-right: 10px">FNSKU:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 2">
                  <span style="margin-right: 10px">{{ $t("cart.cart25") }}:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 3">
                  <span style="margin-right: 10px">{{ $t("cart.cart26") }}:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 4">
                  <span style="margin-right: 10px">{{ $t("cart.cart27") }}:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType != 1" class="text-row-2">
                  <span style="margin-right: 10px">品名:</span>
                  <el-tooltip :content="'品名：' + scope.row.goodsNameCus" placement="top" effect="light">
                    <span class="right">{{ scope.row.goodsNameCus }}</span>
                  </el-tooltip>

<!--                  {{ scope.row.goodsNameCus }}-->
                </div>
                <div v-if="scope.row.orderType == 0">
                  <span style="margin-right: 10px">ASIN:</span>{{ scope.row.asin }}
                </div>
              </div>
              <!-- 不良数量 -->
              <div style="text-align: center" v-else-if="item.key === 'badInfo'">
                <div style="text-align: left">
                  <span class="table-cell-title">{{ $t("defe.defe11") }}：</span>
                  <span>{{ scope.row.badCount }}</span>
                </div>
                <div style="text-align: left">
                  <span class="table-cell-title">{{ $t("orderList.orderList35") }}：</span>
                  <span>{{ scope.row.reissueCount }}</span>
                </div>
                <div style="text-align: left">
                  <span class="table-cell-title">{{ $t("orderList.orderList36") }}：</span>
                  <span>{{ scope.row.exchangCount }}</span>
                </div>
              </div>

              <!--检品视频-->
              <!--<div v-else-if="item.key === 'playVideo'">-->
              <!--  <div v-if="scope.row.checkVideo">-->
              <!--    <div v-for="(video, index) in getVideo(scope.row.checkVideo)">-->
              <!--      <el-button-->
              <!--        class="list-btn btn-green"-->
              <!--        @click="handlePlayVideo(video)"-->
              <!--        >{{ $t("OrderBill.OrderBill22")-->
              <!--        }}{{ index + 1 }}</el-button-->
              <!--      >-->
              <!--    </div>-->
              <!--  </div>-->
              <!--</div>-->

              <!-- 其他不需要处理的 -->
              <span v-else>
                {{ scope.row[item.key] }}
              </span>
            </template>
          </el-table-column>
        </lx-table>
        <el-pagination class="lx-page-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" :pager-count="5" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 拆单 -->
    <el-dialog width="80%" :title="$t('orderList.orderList20')" :visible.sync="splitDialogVisible" @close="splitDialogClosed">
      <el-row>
        <el-col :span="12" class="split-col">
          <el-form label-width="125px" class="demo-ruleForm">
            <div class="split-title">{{ $t("orderList.orderList37") }}：</div>
            <div>
              <el-form-item :label="$t('orderList.orderList38')">
                <el-input v-model="originSpiltOrderInfo.id" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList39')">
                <el-select v-model="originSpiltOrderInfo.orderStatus" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option v-for="(item, index) in orderStatusOptions" :key="index" :value="item.value" :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList40')">
                <el-input v-model="originSpiltOrderInfo.goodsCount" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList41')">
                <el-input v-model="originSpiltOrderInfo.refundCount" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList42')">
                <el-input v-model="originSpiltOrderInfo.destroyCount" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('createOrder.createOrder23')">
                <el-select v-model="originSpiltOrderInfo.orderType" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option key="0" value="0" label="FBA"></el-option>
                  <el-option key="1" value="1" :label="$t('running.suspended0')"></el-option>
                  <el-option key="2" value="2" label="YFF"></el-option>
<!--                  <el-option key="3" value="3" label="ZOZO"></el-option>-->
                  <el-option key="4" value="4" label="RSL"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList44')">
                <el-select v-model="originSpiltOrderInfo.categoryFlag" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option key="1" value="1" :label="$t('running.suspended1')"></el-option>
                  <el-option key="0" value="0" :label="$t('running.suspended0')"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
        <el-col :span="12" class="split-col">
          <el-form :model="spiltOrderInfo" :rules="spiltOrderRules" ref="spiltInfoForm" label-width="120px" class="split-form">
            <div class="split-title">{{ $t("orderList.orderList45") }}：</div>
            <div>
              <el-form-item :label="$t('orderList.orderList46')">
                <el-select v-model="spiltOrderInfo.orderStatus" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option v-for="(item, index) in orderStatusOptions" :key="index" :value="item.value" :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('createOrder.createOrder23')">
                <el-select v-model="spiltOrderInfo.orderType" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option key="0" value="0" label="FBA"></el-option>
                  <el-option key="1" value="1" :label="$t('running.suspended0')"></el-option>
                  <el-option key="2" value="2" label="YFF"></el-option>
<!--                  <el-option key="3" value="3" label="ZOZO"></el-option>-->
                  <el-option key="4" value="4" label="RSL"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList47')">
                <el-select v-model="spiltOrderInfo.categoryFlag" :placeholder="$t('address.address38')" size="small" disabled>
                  <el-option key="1" value="1" :label="$t('running.suspended1')"></el-option>
                  <el-option key="0" value="0" :label="$t('running.suspended0')"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('createOrder.createOrder38')" prop="goodsCount">
                <el-input v-model="spiltOrderInfo.goodsCount"></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList48')" prop="refundCount">
                <el-input v-model="spiltOrderInfo.refundCount"></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList49')" prop="destroyCount">
                <el-input v-model="spiltOrderInfo.destroyCount"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="splitDialogVisible = false">{{ $t("cancel") }}</el-button>
        <el-button class="form-btn btn-blue" @click="splitSave('spiltInfoForm')">{{ $t("submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 提醒 -->

    <el-dialog :title="$t('orderList.orderList23')" :visible.sync="replyDialogVisible" width="50%" @close="replyDialogClose">
      <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="140px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item :label="$t('orderList.orderList50')">
          <span>{{ $t("orderList.orderList51") }}</span>
        </el-form-item>
        <el-form-item :label="$t('orderList.orderList52')">
          <span>{{ replyMessageInfo.id }}</span>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item :label="$t('orderList.orderList53')" prop="remindingTitle">
          <el-input maxlength="100" v-model="replyInfo.remindingTitle"></el-input>
        </el-form-item>
        <el-form-item :label="$t('orderList.orderList54')" prop="remindingContent">
          <!-- <el-input v-model="replyInfo.remindingContent"></el-input> -->
          <quill-editor ref="text" v-model="replyInfo.remindingContent" :options="editorOption" />
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('orderList.orderList55')">
          <el-upload class="editor-slide-upload" action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj" :multiple="true" :file-list="listObj"
            :show-file-list="true" list-type="picture-card" accept="image/png,image/jpeg" :on-remove="handleImgRemove" :on-success="handleImgSuccess"
            :on-exceed="handleExceed" :before-upload="beforeImgUpload" :on-preview="handlePictureCardPreview" :limit="9">
            <el-button size="small" type="primary" class="btn">{{
              $t("upload.button")
            }}</el-button>
            <div ref="preview" @paste="handlePaste" class="paste-img"></div>
            <el-dialog :append-to-body="true" :visible.sync="viewVisible">
              <img width="100%" :src="viewImageUrl" alt="" />
            </el-dialog>
          </el-upload>
        </el-form-item>
        <!-- 上传附件 -->
        <el-form-item :label="$t('createOrder.createOrder117')">
          <el-upload class="editor-slide-upload" action="" :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="beforeUploadFile"
            :before-remove="beforeRemove" :on-success="handleOrderInfo" :multiple="true" :show-file-list="true" :limit="3" :on-exceed="handleAnnexExceed"
            :file-list="attachmentList" :http-request="excelUploadRequest">
            <el-button class="search-btn btn-blue">{{
              $t("createOrder.createOrder117")
            }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="replyDialogClose">{{
          $t("cancel")
        }}</el-button>
        <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">{{
          $t("submit")
        }}</el-button>
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image" />
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <!--    计算费用-->
    <el-dialog :title="$t('orderList.orderList23')" :visible.sync="visible1" width="30%" show-close center>
      <div class="display-row mb-8" v-if="falg">
        <span class="fz-num">{{ $t("orderList.orderList135") }}：{{ numTotal }}</span>
        &nbsp; &nbsp;
        <span class="fz-num">{{ $t("orderList.orderList120") }}：{{ num
          }}{{ $t("orderList.orderList121") }}</span>
      </div>
      <div class="mb-8">{{ $t("orderList.orderList171") }}</div>
      <div class="mb-8">{{ $t("orderList.orderList172") }}</div>
      <!-- {{ $t("orderList.orderList131") }}{{ this.selectedOrders.length
      }}{{ $t("orderList.orderList132") }} -->
      <div style="text-align: right">
        <!-- <el-button class="form-btn btn-gray" @click="visible1 = false">{{
          $t("cancel")
        }}</el-button> -->
        <el-button class="form-btn btn-blue" @click="visible1 = false">{{
          $t("confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <!--    计算费用-->
    <el-dialog :title="$t('orderList.orderList23')" :visible.sync="visible2" width="30%" show-close center>
      <div class="display-row mb-8" v-if="falg">
        <span class="fz-num">{{ $t("orderList.orderList135") }}：{{ numTotal }}</span>
        &nbsp; &nbsp;
        <span class="fz-num">{{ $t("orderList.orderList120") }}：{{ num
          }}{{ $t("orderList.orderList121") }}</span>

      </div>
      <div v-if="falg" class="mb-8">{{ $t("orderList.orderList171") }}</div>
      <div v-if="falg" class="mb-8">{{ $t("orderList.orderList172") }}</div>
      <div v-if="!falg">
        {{ $t("orderList.orderList133") }}{{ this.total
        }}{{ $t("orderList.orderList134") }}
      </div>

      <div style="text-align: right">
        <el-button class="form-btn btn-gray" v-if="!falg" @click="visible2 = false">{{ $t("cancel") }}</el-button>
        <el-button class="form-btn btn-blue" @click="!falg ? calculate() : (visible2 = false)">{{ $t("confirm") }}</el-button>
      </div>
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>

    <el-dialog title="消息回复" :visible.sync="dialogVisibleMessageReply" width="40%" center>
      <div style="padding: 10px">
        <el-form ref="form" :model="formMsg" label-width="90px">
          <el-form-item label="用户ID：">
            <el-input v-model="formMsg.name"></el-input>
          </el-form-item>
          <el-form-item label="消息类型：">
            <el-input v-model="formMsg.name"></el-input>
          </el-form-item>
          <el-form-item label="订单编号：">
            <el-input v-model="formMsg.name"></el-input>
          </el-form-item>
          <el-form-item label="标题：">
            <el-input v-model="formMsg.name"></el-input>
          </el-form-item>
          <el-form-item label="回复内容：">
            <el-input type="textarea" v-model="formMsg.desc"></el-input>
          </el-form-item>
          <el-form-item label="图片："> </el-form-item>
          <el-form-item label="附件："> </el-form-item>
          <el-form-item style="text-align: center">
            <el-button>取消</el-button>
            <el-button type="primary">发 送</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisibleMessageReply = false">取 消</el-button>
        <el-button
          type="primary"
          @click="dialogVisibleMessageReply = false"
        >确 定</el-button>
      </span> -->
    </el-dialog>
    <!-- <el-dialog title="消息详情" :visible.sync="dialogTableVisible">
      <el-table :data="gridData" border>
        <el-table-column property="date" label="操作"></el-table-column>
        <el-table-column property="name" label="消息状态"></el-table-column>
        <el-table-column property="address" label="标题"></el-table-column>
        <el-table-column property="date" label="内容"></el-table-column>
        <el-table-column property="name" label="图片"></el-table-column>
        <el-table-column property="address" label="附件"></el-table-column>
        <el-table-column property="date" label="消息类型"></el-table-column>
        <el-table-column property="name" label="关联单号"></el-table-column>
        <el-table-column property="address" label="发送时间"></el-table-column>
      </el-table>
      <div style="margin: 20px 0;font-size: 18px;color: #303133;">历史对话</div>
      <el-table :data="gridData" border>
        <el-table-column property="date" label="发送人"></el-table-column>
        <el-table-column property="name" label="消息状态"></el-table-column>
        <el-table-column property="address" label="标题"></el-table-column>
        <el-table-column property="date" label="内容"></el-table-column>
        <el-table-column property="name" label="图片"></el-table-column>
        <el-table-column property="address" label="附件"></el-table-column>
        <el-table-column property="date" label="消息类型"></el-table-column>
        <el-table-column property="name" label="关联单号"></el-table-column>
        <el-table-column property="address" label="发送时间"></el-table-column>
      </el-table>
    </el-dialog> -->
  </div>
</template>

<script>
const toolbarOptions = [
  ["bold"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
]
import LxTable from "@/components/LxTable"
import ChildCode from "@/components/ChildCode/index.vue"
import { columns as originColumns } from "./columns"
import { timerLineFeed } from "@/assets/js/utils"
import { getRouteQueryCache, setRouteQueryCache } from "@/assets/js/routeQueryCache"
import LxSort from "@/components/LxSort/index"
import Oss from "../../../assets/js/oss.js"
import tableCon from "../../../views/tableContainer"
import { CreatedUrl } from "@/class"
export default {
  components: {
    LxTable,
    LxSort,
    tableCon,
    ChildCode,
  },
  name: "orderList",
  data () {
    // 自定义邮箱校验规则
    const checkGoodsCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) <= 0 ||
          parseInt(value) >= parseInt(this.originSpiltOrderInfo.goodsCount)
        ) {
          callback(new Error(this.$t("orderList.orderList56")))
        }
        callback()
      } else {
        callback(new Error(this.$t("orderList.orderList57")))
      }
    }
    const checkRefundCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) < 0 ||
          parseInt(value) > parseInt(this.originSpiltOrderInfo.refundCount)
        ) {
          callback(new Error(this.$t("orderList.orderList58")))
        }
        callback()
      } else {
        callback(new Error(this.$t("orderList.orderList59")))
      }
    }
    const checkDestroyCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) < 0 ||
          parseInt(value) > parseInt(this.originSpiltOrderInfo.destroyCount)
        ) {
          callback(new Error(this.$t("orderList.orderList60")))
        }
        callback()
      } else {
        callback(new Error(this.$t("orderList.orderList61")))
      }
    }
    return {
      // isClientManage: this.$store.state.isClientManage,
      viewImageUrl: "",
      viewVisible: false,
      isActive: true,
      dialogTableVisible: false,
      dialogVisibleMessageReply: false,
      num: 0,
      visible1: false,
      visible2: false,
      falg: false,
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      menuSettingData: {
        menuId: "orderList",
      },
      queryInfo: {
        id: "",
        trackingNumberCn: "",
        trackingNumberJpn: "",
        orderStatus: "",
        receiver: "",
        customerUserId: "",
        asin: "",
        createTimeStart: null,
        createTimeEnd: null,
        pageSize: 10,
        pageNum: 1,
      },
      orderData: {
        total: 0,
        pendingPurchaseCount: 0,
        purchasedCount: 0,
        waitWarehouseCount: 0,
        arrivalCount: 0,
        warehouseStorageCount: 0,
        waitPayCount: 0,
        badOrderCount: 0,
        finishCount: 0,
        disenableCount: 0,
        waitApplyCount: 0,
        checkingCount: 0,
        checkedCount: 0,
      },

      visible: false,
      currentdate: "",
      imgurl: "",
      orderStatusQuery: [],
      orderStatusOptions: [],
      orderList: [],
      splitDialogVisible: false,
      originSpiltOrderInfo: {},
      spiltOrderInfo: {},
      total: 0,
      editOrderStatus: [
        "0",
        "1",
        "2",
        "4",
        "8",
        "24",
        "26",
        "40",
        "28",
        "32",
        "36",
        "82",
        "12",
        "16",
      ],
      storeKeepingStatus: [
        "0",
        "4",
        "8",
        "24",
        "26",
        "40",
        "28",
        "32",
        "36",
        "82",
      ],
      numTotal: 0,
      billOrderStatus: ["48", "88", "68", "52", "72", "84"],
      billOrderPayStatus: ["44", "64", "80"],
      spiltOrderRules: {
        goodsCount: [
          {
            required: true,
            message: this.$t("orderList.orderList57"),
            trigger: "change",
          },
          { validator: checkGoodsCount },
        ],
        refundCount: [
          {
            required: true,
            message: this.$t("orderList.orderList59"),
            trigger: "change",
          },
          { validator: checkRefundCount },
        ],
        destroyCount: [
          {
            required: true,
            message: this.$t("orderList.orderList61"),
            trigger: "change",
          },
          { validator: checkDestroyCount },
        ],
      },
      attachmentList: [],
      listObj: [],
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      replyInfo: {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
        attachment: "",
      },
      rules: {
        remindingTitle: [
          {
            required: true,
            message: this.$t("orderList.orderList62"),
            trigger: "blur",
          },
        ],
        remindingContent: [
          {
            required: true,
            message: this.$t("orderList.orderList63"),
            trigger: "blur",
          },
        ],
      },
      orderIds: "",
      exorderIds: "",
      orderIdsArr: [],
      replyMessageInfo: {},
      replyDialogVisible: false,
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          },
        },
      },
      selectedOrders: [],
      configLists: {
        // logisticsCompanyConfigList:[], //快递
        inspectionConfigList: [], //标签
        // boxConfigList:[],//装箱
        // oppConfigList:[] //opp袋
      },
      fbaOption: [
        {
          label: this.$t("running.suspended0"),
          value: "1",
        },
        {
          label: "FBA",
          value: "0",
        },
        {
          label: "YFF",
          value: "2",
        },
        /*{
          label: "ZOZO",
          value: "3",
        },*/
        {
          label: "RSL",
          value: "4",
        },
      ],
      formMsg: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      isSame: true,
    }
  },
  activated () {
    this.getStatisticalNum()
    this.getAsyncColumns().then(() => {
      this.getOrderList()
    })
  },
  created () {
    this.restoreQueryState()
    this.orderStatusOptions = [
      { value: "0", label: this.$t("orderList.orderList8") },
      { value: "1", label: this.$t("orderList.orderList6") },
      { value: "2", label: this.$t("orderList.orderList7") },
      { value: "4", label: this.$t("orderList.orderList64") },
      { value: "8", label: this.$t("orderList.orderList65") },
      { value: "12", label: this.$t("orderList.orderList66") },
      { value: "16", label: this.$t("orderList.orderList10") },
      { value: "20", label: this.$t("orderList.orderList33") },
      { value: "24", label: this.$t("orderList.orderList34") },
      { value: "26", label: this.$t("orderList.orderList67") },
      { value: "28", label: this.$t("orderList.orderList68") },
      { value: "32", label: this.$t("orderList.orderList69") },
      { value: "36", label: this.$t("orderList.orderList70") },
      { value: "40", label: this.$t("orderList.orderList71") },
      { value: "44", label: this.$t("orderList.orderList11") },
      { value: "48", label: this.$t("orderList.orderList72") },
      { value: "52", label: this.$t("orderList.orderList73") },
      { value: "56", label: this.$t("status.status4") },
      { value: "60", label: this.$t("orderList.orderList74") },
      { value: "64", label: this.$t("orderList.orderList75") },
      { value: "68", label: this.$t("orderList.orderList76") },
      { value: "72", label: this.$t("orderList.orderList77") },
      { value: "76", label: this.$t("orderList.orderList78") },
      { value: "80", label: this.$t("orderList.orderList79") },
      { value: "82", label: this.$t("orderList.orderList80") },
      { value: "84", label: this.$t("orderList.orderList81") },
      { value: "88", label: this.$t("orderList.orderList82") },
    ]
    this.orderStatusQuery = [
      { value: "4", label: this.$t("orderList.orderList64") },
      { value: "8", label: this.$t("orderList.orderList65") },
      { value: "12", label: this.$t("orderList.orderList66") },
      { value: "16", label: this.$t("orderList.orderList10") },
      { value: "20", label: this.$t("orderList.orderList33") },
      { value: "44", label: this.$t("orderList.orderList11") },
      { value: "48", label: this.$t("orderList.orderList72") },
      { value: "88", label: this.$t("orderList.orderList82") },
    ]
    this.getStatisticalNum()
    this.getAsyncColumns().then(() => {
      this.getOrderList()
    })
    // this.getConfigLists();
  },
  computed: {
    isClientManage() {
      return this.$store.state.isClientManage
    },
    shopNumOnlyShowTotal () {
      return [1, 2, 3, 4, 10, 12].includes(this.curIndex)
    },
    hideCheckReportColumn () {
      return [1, 2, 3, 4, 5, 9, 10, 12].includes(this.curIndex)
    },
    hideBadInfoColumn () {
      return this.curIndex !== 9
    },
    createTimeStartPickerOptions () {
      const endDate = this.getCreateDateTimestamp(this.queryInfo.createTimeEnd)
      return {
        disabledDate: (date) => endDate !== null && date.getTime() > endDate,
      }
    },
    createTimeEndPickerOptions () {
      const startDate = this.getCreateDateTimestamp(this.queryInfo.createTimeStart)
      return {
        disabledDate: (date) => startDate !== null && date.getTime() < startDate,
      }
    },
    displayColumns () {
      const columns = this.asyncColumns || []
      const hiddenKeys = []
      if (this.hideCheckReportColumn) hiddenKeys.push("checkReport")
      if (this.hideBadInfoColumn) hiddenKeys.push("badInfo")
      if (hiddenKeys.length === 0) return columns
      return columns.filter((item) => !hiddenKeys.includes(item.key))
    },
  },
  methods: {
    restoreQueryState () {
      const cache = getRouteQueryCache('orderList')
      if (!cache) return

      if (cache.queryInfo) {
        this.queryInfo = { ...this.queryInfo, ...cache.queryInfo }
      }
      if (typeof cache.curIndex === 'number') {
        this.curIndex = cache.curIndex
      }
    },
    saveQueryState () {
      setRouteQueryCache('orderList', {
        queryInfo: this.queryInfo,
        curIndex: this.curIndex,
      })
    },
    getCreateTimeTimestamp (value) {
      if (!value) return null
      if (typeof value === "number") return value
      if (value instanceof Date) return value.getTime()

      const dateTime = String(value).split(" ")
      const dateParts = dateTime[0].split("-").map(Number)
      const timeParts = (dateTime[1] || "00:00:00").split(":").map(Number)
      return new Date(
        dateParts[0],
        dateParts[1] - 1,
        dateParts[2],
        timeParts[0] || 0,
        timeParts[1] || 0,
        timeParts[2] || 0
      ).getTime()
    },
    getCreateDateTimestamp (value) {
      if (!value) return null
      const date = new Date(this.getCreateTimeTimestamp(value))
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
    },
    handleCreateTimeStartChange (value) {
      const startTime = this.getCreateTimeTimestamp(value)
      const endTime = this.getCreateTimeTimestamp(this.queryInfo.createTimeEnd)
      if (startTime !== null && endTime !== null && startTime > endTime) {
        this.queryInfo.createTimeEnd = null
      }
    },
    handleCreateTimeEndChange (value) {
      const startTime = this.getCreateTimeTimestamp(this.queryInfo.createTimeStart)
      const endTime = this.getCreateTimeTimestamp(value)
      if (startTime !== null && endTime !== null && endTime < startTime) {
        this.queryInfo.createTimeStart = null
      }
    },
    // 检品报告-查看
    checkReportView (url) {
      CreatedUrl.openUrl(url)
    },
    //检品报告-下载
    checkReportDownload (url) {
      CreatedUrl.urlDown(url, "检品报告书.pdf")
    },
    handlePictureCardPreview (file) {
      this.viewImageUrl = file.url
      this.viewVisible = true
    },
    async handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地")
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片")
        return
      }
      let formdata = new FormData()
      formdata.append("file", file)
      // 数据保存
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      )
      if (res.code === 200) {
        this.listObj.push({
          name: res.data.fileName,
          url: res.data.filePath,
          hasSuccess: true,
          uid: Date.now(),
        })
      }
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i]
        if (file.name == attach.name) {
          this.attachmentList.splice(i, 1)
        }
      }
    },
    handlePreview () {
      // console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `${this.$t("createOrder.createOrder118")},${this.$t(
          "createOrder.createOrder92"
        )} ${files.length} ${this.$t("createOrder.createOrder93")},${this.$t(
          "createOrder.createOrder94"
        )} ${files.length + fileList.length} ${this.$t(
          "createOrder.createOrder93"
        )}`
      )
    },
    handleAnnexExceed (files, fileList) {
      this.$message.warning(
        `${this.$t("createOrder.createOrder119")},${this.$t(
          "createOrder.createOrder92"
        )} ${files.length} ${this.$t("createOrder.createOrder93")},${this.$t(
          "createOrder.createOrder94"
        )} ${files.length + fileList.length} ${this.$t(
          "createOrder.createOrder93"
        )}`
      )
    },
    beforeUploadFile (file) {
      const extension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase()
      // const size = file.size / 1024 / 1024
      if (
        extension !== ".xls" &&
        extension !== ".xlsx" &&
        extension !== ".pdf" &&
        extension !== ".ai"
      ) {
        this.$message.warning(this.$t("orderList.orderList137"))
        return false
      }
      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    // 批量导入
    async excelUploadRequest (file) {
      let formdata = new FormData()
      formdata.append("file", file.file)
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      )
      if (res.code === 200) {
        let { fileName, filePath } = res.data
        this.attachmentList.push({ name: file.file.name, url: filePath })
      }
    },
    beforeRemove () {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}？`);
    },
    // 批量导入成功回调
    handleOrderInfo () {
      console.log("success")
      // console.log(data)
    },
    // 计算所选金额
    getNum () {
      let data = this.queryInfo
      data.orderIds = this.orderIds
      this.$http
        .get("order/getAmountsPayable", {
          params: data,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.falg = true
            this.num = res.data.data
            this.exorderIds = this.orderIds
            // this.visible1 = false;
            // this.visible2 = false;
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    calculate () {
      if (this.selectedOrders.length > 0) {
        this.selectedOrders.forEach((item) => {
          this.orderIdsArr.push(item.id)
          this.orderIds = this.orderIdsArr.join(",")
        })
        this.numTotal = this.selectedOrders.length
      } else {
        this.orderIds = ""
        this.numTotal = this.total
      }
      this.getNum()
      this.falg = true
    },
    // 计算费用
    calculateCost () {
      if (this.selectedOrders.length === 0) {
        this.$message.error(this.$t("orderList.orderList125"))
        return
      }
      this.orderIdsArr = []
      this.num = 0
      if (this.selectedOrders.length > 0) {
        this.selectedOrders.forEach((item) => {
          this.orderIdsArr.push(item.id)
          this.orderIds = this.orderIdsArr.join(",")
        })
        this.visible1 = true
        this.getNum()
        this.falg = true
      }
      // else {
      //   // this.$message.error(this.$t('orderList.orderList125'))
      //   this.visible2 = true
      // }
    },
    // 重新计算
    recalculate () {
      if (this.selectedOrders.length > 0) {
        this.orderIdsArr = []
        this.selectedOrders.forEach((item) => {
          this.orderIdsArr.push(item.id)
        })
        this.orderIdsArr = Array.from(new Set(this.orderIdsArr))
        this.orderIds = this.orderIdsArr.join(",")
        this.getNum()
        this.falg = true
      } else {
        this.$message.error(this.$t("orderList.orderList125"))
      }
    },
    // 费用导出
    expenseExport () {
      this.getNowFormatDate()
      this.orderIdsArr = []
      this.selectedOrders.forEach((item) => {
        this.orderIdsArr.push(item.id)
      })
      this.orderIdsArr = Array.from(new Set(this.orderIdsArr))
      this.orderIds = this.orderIdsArr.join(",")
      let data = this.queryInfo
      data.orderIds = this.orderIds
      this.$http({
        url: "order/exportWaitPayOrder",
        method: "get",
        params: data,
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a")
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
          link.style.display = "none"
          //设置连接
          link.href = URL.createObjectURL(blob)
          link.download = `費用${this.currentdate}.xlsx`
          document.body.appendChild(link)
          //模拟点击事件
          link.click()
        })
        .catch((err) => {
          // console.log(err);
        })
    },
    // 当前日期
    getNowFormatDate () {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      if (month >= 1 && month <= 9) month = "0" + month // 如果月份是个位数，在前面补0
      if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate // 如果日是个位数，在前面补0
      this.currentdate = `${year}${month}${strDate}${hour}${minute}${second}`
    },
    // 去充值
    goRecharge () {
      this.$router.push({ path: "/recharge", query: { num: this.num } })
    },
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        this.$http
          .get("menu/menuSetting", {
            params: {
              menuId: "orderList",
            },
          })
          .then((res) => {
            let savedColumns = []
            if (res.data.code === 200 && res.data.data) {
              this.menuSettingData = res.data.data
              try {
                savedColumns = JSON.parse(res.data.data.menuSetting || "[]")
              } catch (error) {
                savedColumns = []
              }
            }

            const columnMap = new Map(
              this.originColumns.map((item) => [item.key, item])
            )
            const savedKeys = Array.isArray(savedColumns)
              ? savedColumns.map((item) => item && item.key).filter(Boolean)
              : []
            const uniqueSavedKeys = [...new Set(savedKeys)]
            const selectedColumns = uniqueSavedKeys
              .filter((key) => columnMap.has(key))
              .map((key) => ({ ...columnMap.get(key), isShow: true }))

            if (selectedColumns.length > 0) {
              const selectedKeys = new Set(uniqueSavedKeys)
              const noSelectList = this.originColumns
                .filter((item) => !selectedKeys.has(item.key))
                .map((item) => ({ ...item, isShow: false }))
              this.columns = selectedColumns.concat(noSelectList)
              this.asyncColumns = selectedColumns
            } else {
              this.columns = this.originColumns.map((item) => ({
                ...item,
                isShow: true,
              }))
              this.asyncColumns = this.columns
            }
            resolve()
          })
      })
    },
    // 保存选择的列
    doSaveColumns (list) {
      var my = this
      var url = "menu/updateMenuSetting"
      this.menuSettingData.menuSetting = JSON.stringify(
        list.map((item) => ({ key: item.key }))
      )
      this.$http.post(url, this.menuSettingData).then((res) => {
        if (res.data.code === 200) {
          this.isVisibleSort = false
          my.$message({
            type: "success",
            message: this.$t("orderList.orderList83"),
          })
          this.queryInfo.pageNum = 1
          this.getAsyncColumns().then(() => {
            this.getOrderList()
          })
        } else {
          my.$message({
            type: "warning",
            message: this.$t("orderList.orderList84"),
          })
        }
      })
    },
    imgclick (url, visible) {
      // this.$refs.pasteInput.focus()
      this.autofocus = true
      this.visible = true
      this.imgurl = url
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 加入购物车
    doAddCart () {
      if (this.selectedOrders.length > 0) {
        const idList = this.selectedOrders.map((item) => item.id)
        const url = "shopping/vehicle/copy/add"
        const params = {
          idList,
        }
        this.$http.post(url, params).then(() => {
          this.$message.success(this.$t("success"))
        })
      } else {
        this.$message.error(this.$t("orderList.orderList125"))
      }
    },
    orderSelectedChanged (val) {
      this.selectedOrders = val
      // this.isSame = val.every(item => item.userName === val[0].userName);
      this.isSame = val.every(item => {
        const base = val[0];

        const baseKey = base.clientManagerUserName
            ? base.clientManagerUserName
            : base.userName;

        const itemKey = item.clientManagerUserName
            ? item.clientManagerUserName
            : item.userName;

        return itemKey === baseKey;
      });
      console.log('this.selectedOrders',this.selectedOrders)
      console.log('this.selectedOrders',this.isSame)
      this.numTotal = val.length
    },
    queryInfoClear () {
      this.queryInfo = {
        id: "",
        trackingNumberCn: "",
        trackingNumberJpn: "",
        orderStatus: "",
        receiver: "",
        asin: "",
        createTimeStart: null,
        createTimeEnd: null,
        pageSize: 10,
        pageNum: 1,
      }
      this.curIndex = 0
      this.orderDateRangeValue = []
      this.shipDateRangeValue = []
      this.searchList();
    },
    searchList () {
      this.queryInfo.pageNum = 1
      this.getOrderList()
      this.getStatisticalNum()
      // if(!this.queryInfo.id && !this.queryInfo.trackingNumberCn && !this.queryInfo.orderStatus && !this.queryInfo.receiver && !this.queryInfo.createTimeStart && !this.queryInfo.createTimeEnd ){
      //   this.falg = false
      //   this.num = 0
      // }
    },
    async quickSave (val, row) {
      const { data: res } = await this.$http.post("/order/quickSave", {
        orderId: row.id,
        goodsNumber: val,
        quickSaveType: 8,
      })
      console.log(res)
    },
    async getOrderList () {
      const { data: res } = await this.$http.get("order/list", {
        params: this.queryInfo,
      })
      this.orderList = res.data.list
      this.orderListCopy = res.data.list
      this.total = res.data.total
      this.isLoading = false
      // if(this.queryInfo.id || this.queryInfo.trackingNumberCn || this.queryInfo.orderStatus || this.queryInfo.receiver || this.queryInfo.createTimeStart || this.queryInfo.createTimeEnd ) this.getNum()
    },
    async getStatisticalNum () {
      //获取
      const { data: res } = await this.$http.get("order/orderCount", {
        params: this.queryInfo,
      })
      this.orderData = res.data
    },
    quickSearchList (val, index) {
      this.curIndex = index
      console.log('this.curIndex',this.curIndex)
      this.queryInfo.pageNum = 1
      this.queryInfo.orderStatus = val
      this.getOrderList()
      this.getStatisticalNum()
    },
    toTongkunDetail (row) {
      this.$router.push({
        name: "buddleOrderDetail",
        query: {
          id: row.tongkunId,
        },
      })
    },
    toOrderDetail (row) {
      this.$router.push({
        name: "orderDetail",
        query: {
          id: row.id,
          customerId: row.customerUserId,
          isEdit: "0",
        },
      })
      this.$store.commit("addKeepAliveCache", "orderList")
    },
    toGoodsDetail (row) {
      window.open(row.taobaoUrl, "_blank")
    },
    saveTrackingNumberCn (row) {
      this.saveTrackingNumberCnPost(row)
    },
    async saveTrackingNumberCnPost (row) {
      const { data: res } = await this.$http.post(
        "order/updateTrackingNumberCn",
        { orderId: row.id, trackingNumberCn: row.trackingNumberCn }
      )
      if (res.code === 200) {
        //await this.getOrderList();
      } else {
        this.$message.error(res.message)
        await this.getOrderList()
        this.getStatisticalNum()
      }
    },
    //支付
    toOrderBillPay (row) {
      this.$router.push({
        name: "orderBill",
        query: {
          id: row.id,
          isEdit: "1",
        },
      })
    }, //账单
    toOrderBill (row) {
      this.$router.push({
        name: "orderBill",
        query: {
          id: row.id,
          isEdit: "0",
        },
      })
    },
    toEditOrder (row) {
      this.$router.push({
        name: "orderDetail",
        query: {
          id: row.id,
          customerId: row.customerUserId,
          isEdit: "1",
        },
      })
      this.$store.commit("addKeepAliveCache", "orderList")
    },
    toRefundOrderCannel (row) {
      this.$confirm(this.$t("orderList.orderList86"), "", {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/rejectCannel/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: this.$t("loginR.login13"),
            })
            await this.getOrderList()
            this.getStatisticalNum()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList87"),
          })
        })
    },
    toRefundOrder (row) {
      this.$confirm(
        this.$t("orderList.orderList110"),
        this.$t("orderList.orderList16"),
        {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/rejectByCus/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: this.$t("loginR.login13"),
            })
            await this.getOrderList()
            this.getStatisticalNum()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList87"),
          })
        })
    },
    toDestroyOrder (row) {
      let orderStatus = row.orderStatus
      let confirmMsg = this.$t("orderList.orderList89")
      if (orderStatus != "0" && orderStatus != "4") {
        confirmMsg = this.$t("orderList.orderList90")
      }

      this.$confirm(confirmMsg, this.$t("orderList.orderList18"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/destroyByCus/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: this.$t("orderList.orderList91"),
            })
            await this.getOrderList()
            this.getStatisticalNum()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList92"),
          })
        })
    },
    toDestroyOrderCannel (row) {
      let orderStatus = row.orderStatus
      let confirmMsg = this.$t("orderList.orderList93")
      this.$confirm(confirmMsg, this.$t("orderList.orderList18"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/destroyCannel/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: this.$t("orderList.orderList91"),
            })
            await this.getOrderList()
            this.getStatisticalNum()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList92"),
          })
        })
    },
    toStoreKeeping (row) {
      this.$confirm(
        this.$t("orderList.orderList94"),
        this.$t("orderList.orderList47"),
        {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/storeKeeping/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: this.$t("orderList.orderList95"),
            })
            await this.getOrderList()
            this.getStatisticalNum()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList96"),
          })
        })
    },
    toSendOrder (row) {
      this.$confirm(
        this.$t("orderList.orderList97"),
        this.$t("orderList.orderList98"),
        {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/applySendOrder/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: this.$t("orderList.orderList99"),
            })
            await this.getOrderList()
            this.getStatisticalNum()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList100"),
          })
        })
    },
    toCancelOrder (row) {
      this.$confirm(
        this.$t("orderList.orderList101"),
        this.$t("orderList.orderList102"),
        {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/cancel/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: this.$t("wzbg.wz18"),
            })
            await this.getOrderList()
            this.getStatisticalNum()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList103"),
          })
        })
    },
    toSpiltOrder (row) {
      this.splitDialogVisible = true
      this.originSpiltOrderInfo = row
      this.spiltOrderInfo = JSON.parse(JSON.stringify(row))
    },
    splitDialogClosed () {
      this.splitDialogVisible = false
    },
    splitSave (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(
            "cusArrOrder/spilt",
            this.spiltOrderInfo
          )
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message,
            })
            this.splitDialogClosed()
            await this.getOrderList()
            this.getStatisticalNum()
          } else {
            this.$message({
              type: "warning",
              message: res.message,
            })
          }
        }
      })
    },
    replySave (formName) {
      //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply()
          this.replyDialogVisible = false
          this.btnReplyFlag == 0
        } else {
          this.$message.error(this.$t("orderList.orderList104"))
          return false
        }
      })
    },
    messageAdd (row) {
      const { MessageSend } = this
      // MessageSend.message.onAdd("提醒", [
      //   {
      //     key: "orderId",
      //     type: "elInput", //view
      //     label: "订单Id：",
      //     vModel: row.id,
      //     vBind: { disabled: true },
      //   },
      // ]);
      MessageSend.message.onAdd("", row)
    },
    remind (row) {
      //提醒
      this.handleImgSubmit()
      this.replyDialogVisible = true
      this.attachmentList = []
      this.listObj = []
      this.replyMessageInfo = row
      this.replyInfo = {
        orderId: row.id,
      }
    },
    clearReplyForm () {
      //弹窗的取消按钮
      this.initReplyForm()
      this.replyDialogVisible = false
    },
    initReplyForm () {
      //初始化弹窗的内容
      this.replyInfo = {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
      }
    },
    replyDialogClose () {
      //关闭提醒弹窗
      this.replyDialogVisible = false
    },
    async addReply () {
      if (!this.handleImgSubmit()) {
        return false
      }
      var url = "cmUser/message/reply"
      const { data: res } = await this.$http.post(url, this.replyInfo)
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        })
      } else {
        this.$message({
          type: "warning",
          message: res.message,
        })
      }
    },
    showImgDialog (index) {
      this.imgDialogVisible = true
    },
    handleImgSubmit () {
      var _this = this
      let arr = []
      Object.keys(_this.listObj).map((v) => {
        arr.push(_this.listObj[v].url)
      })
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(this.$t("orderList.orderList105"))
        return false
      } else {
        if (arr.length > 9) {
          _this.$message.error(this.$t("orderList.orderList138"))
          return false
        }
        _this.replyInfo.replyPicture = arr.toString()
        _this.$emit("successCBK", arr)
        _this.listObj = {}
        _this.imgDialogVisible = false
      }
      if (_this.attachmentList.length > 0) {
        _this.replyInfo.attachment = JSON.stringify(this.attachmentList)
      } else {
        _this.replyInfo.attachment = ""
      }
      return true
    },
    handleImgRemove (file, fileList) {
      // 显示使用
      Oss.imgRemove(file, this.listObj)
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj)
    },
    beforeImgUpload (file) {
      const _self = this
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        _self.$message.error(this.$t("createOrder.createOrder74"))
        return false
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/
      if (specialReg.test(file.name)) {
        _self.$message.error(this.$t("createOrder.specialChar"))
        return false
      }
      const fileName = file.uid
      this.listObj[fileName] = {}
      return new Promise((resolve, reject) => {
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = "" //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10)
            }
            num = new Date().getTime() + num //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy
            _self.imgDataObj.signature = response.data.data.signature
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId
            _self.imgDataObj.key =
              response.data.data.dir + "/order/" + num + "${filename}"
            _self.imgDataObj.dir = response.data.data.dir + "/order"
            _self.imgDataObj.host = response.data.data.host
            _self.imgDataObj.timeStamp = num
            file.timeStamp = num
            Oss.imgCompress(file, this.listObj, resolve, reject)
          })
          .catch((err) => {
            reject(false)
          })
      })
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage
      this.getOrderList()
    },
    // 排序
    toSort () {
      this.isVisibleSort = true
    },
    //播放视频
    handlePlayVideo (param) {
      window.open(param, "_blank")
    },
    // 批量取消
    async handleOrderClear () {
      if(this.selectedOrders.length === 0){
        return this.$message({
          type: 'warning',
          message: this.$t('orderList.orderList125')
        })
      }
      try {
        // 显示确认对话框
        const confirmResult = await this.$confirm(
          // this.curIndex == 1(代购买) this.curIndex == 10(无法购买)'是否确认清除 [无法购买] 计数统计?',
          // this.curIndex == 1 ? this.$t('orderList.orderList170') : this.$t('orderList.orderList158'),
          this.$t('orderList.orderList170'),
          this.$t('prompt.title'),
          {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }
        )

        // 如果用户确认，则执行清除操作
        if (confirmResult) {
          const params = {
            orderIdList: this.selectedOrders.map(v=>{
              return v.id
            })
          }
          console.log('params',params)
          const { data: res } = await this.$http.post('/cusArrOrder/batchCancel',params)
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: this.$t('orderList.orderList165')
            })
            this.getOrderList()
            this.getStatisticalNum()
          } else {
            this.$message({
              type: 'warning',
              message: `${this.$t('orderList.orderList166')}：${res.message || this.$t('orderList.orderList167')}`
              // message: `清除失败：${res.message || '未知错误'}`
            })
          }
        }
      } catch (error) {
        if (error === 'cancel') {
          this.$message({
            type: 'info',
            message: this.$t('orderList.orderList168')
            // message: '已取消操作'
          })
        } else {
          this.$message({
            type: 'error',
            message: `${this.$t('orderList.orderList169')}：${error.message || this.$t('orderList.orderList167')}`
            // message: `发生错误：${error.message || '未知错误'}`
          })
        }
      }
    },
    //保存清除订单数据时间
    async orderClearTimeSave () {
      this.$confirm(this.$t("orderList.orderList155"), '提示', {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: 'warning'
      }).then(async () => {
        let parms = {
          moduleName: "orderCustomerWeb",
        }
        const { data: res } = await this.$http.post("orderClear/save", parms)
        if (res.code === 200) {
          this.$message.success(this.$t('success'))
          this.getStatisticalNum()
          this.getOrderList()
        } else {
          this.$message.error(res.message)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('status.status4')
        })
      })

    },
    //  导出
    orderExport () {
      let ids = undefined
      this.selectedOrders.forEach((item) => {
        if (ids == undefined) {
          ids = item.id
        } else {
          ids += "," + item.id
        }
      })

      let params = {...this.queryInfo};
      params.ids = ids

      // if (params){
      //   let orderStatus = params.orderStatus
      //   if (orderStatus == '999') {
      //     params.orderStatus = "88,24,28,32,40,36,82,83,68";
      //   }else if (orderStatus == '16'){
      //     params.orderStatus = "88,24,28,32,40,36,82,83,68";
      //   }
      // }

      this.$http({
        url: "order/exportOrderList",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        params: params,
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a")
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
          link.style.display = "none"
          //设置连接
          link.href = URL.createObjectURL(blob)
          link.download = `订单列表${this.currentdate}.xlsm`
          document.body.appendChild(link)
          //模拟点击事件
          link.click()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //检品视频
    getVideo (str) {
      if (str != null && str.length > 0) {
        return str.split(",")
      }
      return []
    },
    // 时间字符串换行处理
    timerLineFeed: timerLineFeed,
    // 批量分配
    plfpFunc () {
      console.log(this.selectedOrders,77)
      if(this.selectedOrders.length === 0){
        return this.$message({
          message: this.$t('cnumber.cnumber18'),
          type: 'warning'
        })
      }
      this.$modalDialog(() => import('./components/fenpei.vue'), {
        row: this.selectedOrders,
      }).then(
          () => {
            this.searchList()
          },
          () => {
          }
      )
    },
    // 订单分配
    fpItem (item) {
      console.log(item,88)
      this.$modalDialog(() => import('./components/fenpei.vue'), {
        row: item,
      }).then(
          () => {
            this.searchList()
          },
          () => {
          }
      )
    },
  },
  watch: {
    orderDateRangeValue () {
      this.queryInfo.createTimeStart = this.orderDateRangeValue[0]
      this.queryInfo.createTimeEnd = this.orderDateRangeValue[1]
    },
    shipDateRangeValue () {
      this.queryInfo.sendTimeStart = this.shipDateRangeValue[0]
      this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1]
    },
  },
  beforeRouteLeave (to, from, next) {
    this.saveQueryState()
    next()
  },
};
</script>

<style lang="less" scoped>
.list-btn {
  /*margin-right: 0 !important;*/
}
.paste-img {
  position: absolute;
  top: 0;
  left: 1px;
  width: 1px;
  height: 1px;
  z-index: 999;
}

.lx-text-left-row {
  display: flex;
}

.sku-input /deep/ .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


.table-cell-title {
  width: 80px;
}

.table-cell-title-min {
  width: 50px!important;
  min-width: 50px!important;
  font-size: 12px;
}

.split-col {
  padding-right: 20px;
}

.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container {
  padding: 0;
}

.query-title1 {
  /* padding-right: 10px; */
  height: 30px;
  line-height: 30px;
  min-width: 125px;
  width: auto;
  padding: 0 10px 0 10px;
  text-align: right;
  word-break: break-all;
}

.btn {
  width: 120px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  height: auto;
  overflow: hidden;
}

.lx-flex-end {
  display: flex;
  justify-content: flex-end;
}

.lx-gap-5 {
  gap: 5px;
}

.ml-10 {
  margin-left: 10px;
}

.mr-10 {
  margin-right: 10px;
}

.mr-20 {
  margin-left: 20px !important;
}

.fz-num {
  margin-top: 6px;
  color: red;
}

.mb-8 {
  margin-bottom: 8px;
}

.flex-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.search-btn {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.lx-table-wrapper {
  padding-bottom: 43px;
  box-sizing: content-box;
}

.lx-page-pagination {
  position: absolute;
  right: 0;
  bottom: 5px;
  width: 100%;
  height: 35px;
  background-color: #fff;
}
.goods-info-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  width: fit-content;
  padding: 10px 0;
}
.goods-detail-link {
  border: 2px solid #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
.set-number {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  div {
    width: 50%;
  }
}
.white-space-nowrap {
  white-space: nowrap;
}
</style>

<style>
.dia-btnTop {
  margin-top: 40px;
  text-align: center;
}

.dia-btnTop-Magin-left {
  margin-right: 10px;
}

.dia-btnTop-Magin {
  margin-right: 10px;
}

.dia-content {
  padding: 0 40px;
}

.dia-title-top {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 20px;
}

.dia-title-mid {
  color: #909399;
  margin-bottom: 20px;
}

.dia-btnMid {
  margin-top: 33px;
  text-align: center;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  color: #409eff;
}

.footer-left {
  margin-right: 40px;
}

.table-cell-title-mid{
  /* width: 85px; */
  text-align: right;
}
</style>
